import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const WppRedirect = () => {
  const { telefone } = useParams();

  useEffect(() => {
    if (telefone) {
      // Redireciona para o link do WhatsApp
      window.location.replace(`https://api.whatsapp.com/send?phone=${telefone}`);
    }
  }, [telefone]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f2027 0%, #2c5364 100%)',
      color: '#fff',
      fontFamily: 'inherit',
      fontSize: '1.2rem',
      letterSpacing: '0.05em',
      flexDirection: 'column',
    }}>
      <span>Redirecionando para o WhatsApp...</span>
      <span style={{fontSize: '2rem', marginTop: '1rem'}}>📲</span>
    </div>
  );
};

export default WppRedirect;
